/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const CheckOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m19.875 6.75-10.5 10.5L4.125 12"
})); // Fill


const CheckFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M9.374 17.976c-.2 0-.39-.08-.53-.21l-5.25-5.25a.822.822 0 0 1-.18-.52c.01-.19.09-.37.23-.5.13-.13.31-.21.5-.22.18-.01.37.05.51.17l4.72 4.72 9.97-9.97c.14-.12.33-.18.51-.17.19.01.37.09.5.22.14.13.22.31.23.5s-.06.37-.18.52l-10.5 10.5c-.14.13-.33.21-.53.21z"
})); // DuoTone


const CheckDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m19.875 6.75-10.5 10.5L4.125 12"
}));
/**
  Icon CheckIcon in system group
*/


export const CheckIcon = createIcon('CheckIcon', 'check', 'system', CheckOutline, CheckFill, CheckDuotone, "0 0 24 24");